import {Component, inject, input} from '@angular/core';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzDropdownModule} from 'ng-zorro-antd/dropdown';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzMenuModule} from 'ng-zorro-antd/menu';
import {TranslocoPipe} from '@jsverse/transloco';
import {AppLanguage} from '../../core/i18n/i18n.config';
import {I18nService} from '../../core/i18n/i18n.service';

@Component({
  selector: 'app-language-switcher',
  imports: [NzButtonModule, NzDropdownModule, NzIconModule, NzMenuModule, TranslocoPipe],
  template: `
    <button
      type="button"
      nz-button
      nzType="text"
      nz-dropdown
      nzTrigger="click"
      [nzDropdownMenu]="languageMenu"
      class="language-trigger"
      [attr.aria-label]="'header.language' | transloco"
    >
      <span nz-icon nzType="translation"></span>
      @if (showLabel()) {
        <span class="language-label">{{ i18n.activeLanguageLabel() }}</span>
      }
    </button>

    <nz-dropdown-menu #languageMenu="nzDropdownMenu">
      <ul nz-menu nzSelectable>
        @for (option of options; track option.value) {
          <li nz-menu-item [nzSelected]="i18n.activeLanguage() === option.value" (click)="switchLanguage(option.value)">
            {{ option.label }}
          </li>
        }
      </ul>
    </nz-dropdown-menu>
  `,
  styles: `
    .language-trigger {
      display: inline-flex;
      align-items: center;
      gap: 6px;
    }
  `,
})
export class LanguageSwitcherComponent {
  /** When false, only the translation icon is shown (matches iot-admin shell header). */
  readonly showLabel = input(true);

  protected readonly i18n = inject(I18nService);
  protected readonly options: {label: string; value: AppLanguage}[] = [
    {label: 'English', value: 'en-US'},
    {label: '简体中文', value: 'zh-CN'},
  ];

  async switchLanguage(language: AppLanguage) {
    await this.i18n.setLanguage(language);
  }
}
